module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.redefine.js
// module id = YOG3
// module chunks = 0